<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Add Drug</p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>
            <section class="modal-card-body">
                <!--                  content-->
                <!--                :is-row-checkable="canSelectRow"-->
                <b-table
                        :data="mstDrugDat"
                        :bordered=false
                        :striped=false
                        :checked-rows.sync="checkedRows"
                        checkable
                        narrowed
                        :hoverable=false
                        :focusable=false
                        mobile-cards>

                    <b-table-column   label="Drug Name"    v-slot="props">
                        <span :class="isIDSelected(props.row.id) ? '  title has-text-weight-bold has-text-primary ' : '' "   >
                            {{ props.row.name }}
                        </span>
                    </b-table-column>
                </b-table>

            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"  @click="closeBtn">Cancel</b-button>
                <b-button type="is-success" @click="save">Save</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "SelectDrug",
        props:{
            isShowing : Boolean,
            drugExisting : Array
        },
        computed: {
            ...mapState({
                mstDrugDat: state => state.bact.mstDrugDat,
            })
        },
        methods:{    /* eslint-disable */
            // canSelectRow(row){
            //     if(this.drugExisting.length>0){
            //         var expressionReturn = ""
            //         var first = true
            //         this.drugExisting.forEach(dat=>{
            //             if(first){
            //                 expressionReturn = expressionReturn + `row.id !== ${dat.iddrug}`
            //                 first = false
            //             }else{
            //                 expressionReturn = expressionReturn + ` && row.id !== ${dat.iddrug}`
            //             }
            //         })
            //
            //         return eval(expressionReturn)
            //     }
            //
            //     return true
            //
            // },
            closeBtn(){
               this.$emit('closeSelectDrug')
            },
            save(){
                this.$emit('closeSelectDrugWithData',this.checkedRows)
            },
            isIDSelected(_id){
                const tmp =  this.checkedRows.find(dat=>{
                    return dat.id === _id
                })
                return tmp ? true : false
            }
        },
        data(){
            return{
                checkedRows : []
            }
        },
        // watch:{
        //     isShowing:{
        //         immediate: true,
        //         handler: function (val) {
        //               if(val){
        //                   // console.log(this.drugExisting)
        //                   this.canSelectRow()
        //               }
        //         }
        //     }
        // }
    }
</script>

<style scoped>

</style>